<template>
  <div class="zz">
    <div class="sidebar">
      <div class="close" @click="close">
        <img src="@/assets/img/headerNav/err.svg" alt="" />
      </div>
      <h2>
        <img class="logo" src="@/assets/img/headerNav/headerlog.png" alt="" />
      </h2>
      <div class="line"></div>
      <ul class="menu">
        <li
          v-for="item in menuItems"
          :key="item.name"
          @click="navigate(item.path)"
        >
          {{ item.name }}
          <ul v-if="item.submenu">
            <li v-for="subItem in item.submenu" :key="subItem.id">
              {{ subItem.name }}
            </li>
          </ul>
        </li>
      </ul>
      <div class="icon-box">
        <div class="line"></div>
        <div class="icon">
          <img
            src="@/assets/img/shopdetail/icon1.png"
            @click="gotourl('https://www.instagram.com/fdfurit/')"
            alt=""
          />
          <img
            src="@/assets/img/shopdetail/icon2.png"
            @click="
              gotourl('https://www.facebook.com/profile.php?id=61567074647888')
            "
            alt=""
          />
          <img
            src="@/assets/img/shopdetail/icon3.png"
            @click="
              gotourl(
                'https://api.whatsapp.com/send/?phone=8613512282858&text&type=phone_number&app_absent=0'
              )
            "
            alt=""
          />
          <img
            src="@/assets/img/shopdetail/icon4.png"
            @click="
              gotourl(
                'https://www.linkedin.com/company/tianjin-green-crispy-foods/?viewAsMember=true'
              )
            "
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuItems: [
        { name: this.$t("components[0].headerNav[0]"), path: "home" },
        { name: this.$t("components[0].headerNav[1]"), path: "aboutous" },
        {
          name: this.$t("components[0].headerNav[2]"),
          path: "services",
          submenu: [
            {
              name: this.$t("components[0].headerNav[3]"),
              path: "qualityControl",
            },
            {
              name: this.$t("components[0].headerNav[4]"),
              path: "inspectionReport",
            },
            {
              name: this.$t("components[0].headerNav[5]"),
              path: "customizedSolution",
            },
            { name: this.$t("components[0].headerNav[6]"), path: "rd" },
          ],
        },
        { name: this.$t("components[0].headerNav[7]"), path: "cataLog" },
        {
          name: this.$t("components[0].headerNav[8]"),
          path: "cooperationCase",
        },
        { name: this.$t("components[0].headerNav[9]"), path: "control" },
      ],
    };
  },
  methods: {
    navigate(path) {
      //   this.$router.push(path);
      // 可以在这里进行路由导航等操作
      //   console.log(`选择了菜单: ${index}`);
      this.$router.push({
        name: path,
      });
    },
    close() {
      this.$emit("close");
    },
    gotourl(item) {
      window.open(item);
    },
  },
};
</script>

<style lang="scss">
.zz {
  background: rgba(0, 0, 0, 0.3);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 1800;
  top: 0;
  .sidebar {
    width: 320px;
    height: 100vh;
    background-color: #fff;
    color: #002552;
    padding: 40px;
    position: fixed;
    z-index: 1000;
    text-align: left;
    .close {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    .logo {
      width: 82px;
    }
    .line {
      margin: 32px 0;
    }
    ul {
      list-style-type: none;
      padding: 0;
    }

    .menu li {
      font-family: "Roboto-Bold";
      font-size: 14px;
      line-height: 17px;
      text-align: left;
      cursor: pointer;
      margin-bottom: 32px;
    }
    .menu li ul li {
      padding-left: 20px;
      margin-top: 20px;
      margin-bottom: 0px;
      font-weight: normal;
    }
    .icon-box {
      position: absolute;
      bottom: 88px;
      width: 240px;
      .icon {
        padding: 6px 20px 0;
        img {
          width: 24px;
          height: 24px;
          margin: 0 8px;
        }
      }
    }
  }
}
</style>
